@import '../../../../../../../constants/spacing.module.less';

.bundle-upsell-banner {
  margin-top: @space-20;
}
